/* globals zoomSdk */
import { createAction, createAsyncThunk } from '@reduxjs/toolkit'

let zaConfigTimer

export const zaConfig = createAsyncThunk(
  'app/zaConfig',
  async (query, thunkAPI) => {
    clearTimeout(zaConfigTimer)

    const config = await zoomSdk.config({
      version: '0.16',
      capabilities: [
        'getUserContext',
        'showAppInvitationDialog',
        'onSendAppInvitation',
        'setVirtualBackground',
        'removeVirtualBackground',
        'getAppContext',
        'sendAppInvitation',
        'getCurrentVirtualBackground',
        'onMyMediaChange',
        'onSetVirtualBackground',
        'onRemoveVirtualBackground',
        'addVirtualBackground',
        'zmTextToImage',
        'zmOnTextToImage',
        'openUrl',
        'onThemeModeChange',
      ],
    })

    zaConfigTimer = setTimeout(
      () => {
        thunkAPI.dispatch(zaConfig())
      },
      120 * 60 * 1000
    )

    return config
  }
)

export const cancelZaConfig = createAction('app/cancelZaConfig', () => {
  clearTimeout(zaConfigTimer)
  return {}
})

export const zaGetAppContext = createAsyncThunk(
  'app/zaGetAppContext',
  async (query, thunkAPI) => {
    let appContext
    try {
      appContext = await zoomSdk.getAppContext()
      await fetch('/api/zoomapp/getAppContext/' + appContext.context)
    } catch (error) {
      console.log(error)
    }
    return appContext
  }
)

export const updateStatus = createAction('app/status')
